var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"value":_vm.value,"clearable":_vm.clearable,"size":_vm.size,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"filterable":""},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }